import { Box, styled } from '@mui/material';

type ShadowLength = 'short' | 'medium' | 'long';
type ShadowVariant =
  | 'all'
  | 'horizontal'
  | 'vertical'
  | 'top'
  | 'bottom'
  | 'left'
  | 'right';

const lengthMap: Record<ShadowLength, number> = {
  short: 30,
  medium: 60,
  long: 120,
};

const ShadowBase = styled(Box)({
  position: 'absolute',
  zIndex: 20,
  pointerEvents: 'none',
});

const TopShadow = styled(ShadowBase, {
  shouldForwardProp: p => p !== 'size',
})<{ size: number }>(({ size }) => ({
  top: 0,
  left: 0,
  width: '100%',
  height: `${size}px`,
  background: `linear-gradient(to bottom, #000 0px, transparent ${size}px)`,
}));

const BottomShadow = styled(ShadowBase, {
  shouldForwardProp: p => p !== 'size',
})<{ size: number }>(({ size }) => ({
  bottom: 0,
  left: 0,
  width: '100%',
  height: `${size}px`,
  background: `linear-gradient(to top, #000 0px, transparent ${size}px)`,
}));

const LeftShadow = styled(ShadowBase, {
  shouldForwardProp: p => p !== 'size',
})<{ size: number }>(({ size }) => ({
  top: 0,
  left: 0,
  height: '100%',
  width: `${size}px`,
  background: `linear-gradient(to right, #000 0px, transparent ${size}px)`,
}));
const RightShadow = styled(ShadowBase, {
  shouldForwardProp: p => p !== 'size',
})<{ size: number }>(({ size }) => ({
  top: 0,
  right: 0,
  height: '100%',
  width: `${size}px`,
  background: `linear-gradient(to left, #000 0px, transparent ${size}px)`,
}));

interface OverlayShadowsProps {
  length?: ShadowLength;
  variant?: ShadowVariant;
}

export const OverlayShadows = ({
  length = 'medium',
  variant = 'all',
}: OverlayShadowsProps) => {
  const size = lengthMap[length];

  const renderLeft =
    variant === 'all' || variant === 'vertical' || variant === 'left';
  const renderTop =
    variant === 'all' || variant === 'horizontal' || variant === 'top';
  const renderBottom =
    variant === 'all' || variant === 'horizontal' || variant === 'bottom';
  const renderRight =
    variant === 'all' || variant === 'vertical' || variant === 'right';

  return (
    <>
      {renderTop && <TopShadow size={size} />}
      {renderBottom && <BottomShadow size={size} />}
      {renderLeft && <LeftShadow size={size} />}
      {renderRight && <RightShadow size={size} />}
    </>
  );
};
